/* ============================================================
   HIT: ampliação da foto do produto (DIRECAO-CARD-PDP.md §5.3 e §7, movimento em §10). O botão "Ampliar imagem" da galeria
   (snippets/galeria, [data-zoom]) abre a janela #zoom com a foto que está na galeria; as setas dela e as do teclado andam pelas mesmas fotos
   da cor (HitProduto.passo, assets/hit-produto.js), então fechar devolve a galeria na mesma foto. A janela usa o HitCamadas
   (assets/hit-camadas.js): trava a rolagem, deixa o fundo inerte (inclusive a barra de compra), prende o Tab, fecha com Esc ou com o véu e
   devolve o foco ao botão. O foco inicial vai ao título ([data-camada-foco]). A janela é levada para o <body> no carregamento, como a ajuda
   (assets/hit-conteudo.js): dentro do <main data-fundo> ela ficaria inerte junto com o fundo.
   ============================================================ */
(function () {
  'use strict';
  if (window.HitProdutoZoom) return;
  const LARGURA = 1600; // px da foto ampliada
  let zoom = null, img = null;
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const aberto = () => !!zoom && zoom.classList.contains('on');

  function desenha() {
    const P = window.HitProduto, f = P && P.foto && P.foto();
    if (!zoom || !f || !f.n) return;
    img.setAttribute('src', f.src(LARGURA));
    img.alt = f.alt;
    $$('[data-zoom-passo]', zoom).forEach((b) => { b.hidden = f.n < 2; });
  }
  function abre(origem) {
    const C = window.HitCamadas;
    if (!zoom || !C) { console.error('hit-produto-zoom.js: falta o #zoom ou o hit-camadas.js'); return; }
    desenha();
    C.abrir(zoom, origem);
  }
  function fecha() { if (window.HitCamadas && aberto()) window.HitCamadas.fechar(zoom); }
  function passo(d) { if (window.HitProduto) window.HitProduto.passo(d); }

  function liga() {
    zoom = document.getElementById('zoom');
    if (!zoom) return;
    img = zoom.querySelector('.zoom-foto img');
    if (zoom.parentNode !== document.body) document.body.appendChild(zoom);
    document.addEventListener('hit:produto-foto', () => { if (aberto()) desenha(); });
    document.addEventListener('click', (ev) => {
      const t = ev.target;
      if (!t || !t.closest || ev.defaultPrevented) return;
      let b = t.closest('[data-zoom]');
      if (b) { abre(b); return; }
      if (t.closest('[data-zoom-fechar]')) { fecha(); return; }
      b = t.closest('[data-zoom-passo]');
      if (b) passo(Number(b.dataset.zoomPasso));
    });
    document.addEventListener('keydown', (ev) => {
      if (!aberto() || ev.altKey || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
      if (ev.key === 'ArrowRight') { ev.preventDefault(); passo(1); } else if (ev.key === 'ArrowLeft') { ev.preventDefault(); passo(-1); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', liga, { once: true });
  else liga();
  window.HitProdutoZoom = Object.freeze({ abre, fecha });
})();
